import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bg-header.jpg")